import { model } from "core/util";
import { UniqaLifeContractDetail } from "./UniqaLifeContractDetail";

export const UniqaLife = model.createModelLegacy("UniqaLife", (json) => ({
    idObject: json.idObject,
    isUniqaContract: true,
    contractDetail: UniqaLifeContractDetail.fromServer(json.contractDetail),
}));
